import { useConfig } from '@dhis2/app-runtime';
export const useDebugInfo = () => {
  const {
    appName,
    appVersion,
    systemInfo
  } = useConfig();
  return {
    app_name: appName || null,
    app_version: (appVersion === null || appVersion === void 0 ? void 0 : appVersion.full) || null,
    dhis2_version: (systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.version) || null,
    dhis2_revision: (systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.revision) || null
  };
};
export const useFormattedDebugInfo = () => JSON.stringify(useDebugInfo(), undefined, 2);